var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#363853"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_22430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4421 17.975L44.4657 19.9796L46.4689 34.0046L33.4469 47.0266C33.1812 47.2922 32.8209 47.4414 32.4453 47.4414C32.0696 47.4414 31.7094 47.2922 31.4437 47.0266L17.4187 33.0016C17.1531 32.7359 17.0039 32.3757 17.0039 32C17.0039 31.6244 17.1531 31.2641 17.4187 30.9984L30.4421 17.975ZM31.4437 20.9812L20.4234 32L32.4453 44.0204L43.4641 33.0016L41.9624 22.4828L31.4437 20.9812ZM34.447 29.9968C33.9156 29.4652 33.6171 28.7442 33.6172 27.9925C33.6173 27.6202 33.6906 27.2517 33.8331 26.9078C33.9756 26.564 34.1845 26.2515 34.4477 25.9884C34.711 25.7252 35.0235 25.5165 35.3674 25.3741C35.7113 25.2317 36.0799 25.1585 36.4521 25.1586C37.2038 25.1587 37.9247 25.4574 38.4562 25.9891C38.9876 26.5207 39.2861 27.2417 39.286 27.9935C39.2859 28.7452 38.9871 29.4661 38.4555 29.9975C37.9238 30.529 37.2028 30.8275 36.4511 30.8274C35.6994 30.8272 34.9785 30.5285 34.447 29.9968Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_22430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.75b18a64a14f6004cb30d70296ea356b.svg";
export { ForwardRef as ReactComponent };